import { StatusBar } from "expo-status-bar";
import React from "react";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  TextInput,
  UIManager,
  Platform,
  RefreshControl,
} from "react-native";
import Animated from "react-native-reanimated";
const { multiply, sub } = Animated;
import Text from "app/components/Text";
import * as RootNavigation from "app/utils/RootNavigation.js";
// import ValueListItem from 'app/components/ValueListItem'
import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import prefActions from "app/utils/prefActions";
import storageActions from "app/utils/storageActions";
import { styleSheet, colors, sizes, WIDTH } from "app/utils/styleSheet";
import { Ionicons } from "@expo/vector-icons";
import valueHelpers from "app/utils/valueHelpers";
import textHelpers from "app/utils/textHelpers";
import frequencyHelpers from "app/utils/frequencyHelpers";
// import timeHelpers from 'app/utils/timeHelpers'
import { AntDesign } from "@expo/vector-icons";

import store from "app/redux/store";

import FilterBar from "app/components/FilterBar";
import List from "app/components/List";

export default class ToDo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      ids: [],
      doneIds: [],
      dueIds: [],
      dormantIds: [],
      upcomingIds: [],
      todoIds: [],
      focusIds: [],
      dismissedIds: [],
      values: [],
      datetime: null,
      expandDone: false,
      expandDue: true,
      expandFocus: false,
      expandUpcoming: false,
      expandTodo: false,
      expandDismissed: false,
      expandDormant: false,
    };
  }

  async componentDidMount() {
    console.log("mount subscribe");
    this.subscribe();
    // focus
    this.unsubscribeFocus = this.props.navigation.addListener("focus", () => {
      console.log("nav focus subscribe");
      this.subscribe();
    });
    // if (ENV.WEB) window.addEventListener("focus", this.subscribe);
    this.unsubscribeBlur = this.props.navigation.addListener(
      "blur",
      this.unsubscribe
    );
    // console.log("todo ubsubBlur", this.unsubscribeBlur);
    // if (ENV.WEB) window.addEventListener("blur", this.unsubscribe);
  }

  componentWillUnmount() {
    // this.props.navigation.removeListener("focus");
    this.unsubscribeFocus();
    // if (ENV.WEB) window.removeEventListener("focus", this.subscribe);
    // this.props.navigation.removeListener("blur");
    this.unsubscribeBlur();
    // if (ENV.WEB) window.removeEventListener("blur", this.unsubscribe);
    this.unsubscribe();
  }

  unsubscribe = () => {
    this.unsubscribeRedux?.();
    this.unsubscribeRedux = null;
  };

  subscribe = async () => {
    if (!!this.unsubscribeRedux) {
      console.log("already subscribed!");
      return;
    }
    console.log("subscribing /todo");
    this.unsubscribeRedux = store.subscribe(() => {
      console.log("update store /todo");
      let { app, preferences, values } = store.getState();
      values = valueHelpers.filterToCurrentRevisions(values);
      let { loading, datetime } = app;
      let { todoIds, focusIds, dismissedTodos } = preferences;

      let dueIds = frequencyHelpers.getDueValues(values).map((v) => v.id);
      let doneIds = frequencyHelpers.getDoneToday(values).map((v) => v.id);
      let upcomingIds = frequencyHelpers.getUpcoming(values).map((v) => v.id);
      let dormantIds = frequencyHelpers.getDormantValues(values).map((v) => v.id);
      let dismissedIds = frequencyHelpers.getDismissedIds(values);

      this.setState({
        loading,
        datetime,
        values,
        doneIds,
        dueIds,
        dormantIds,
        upcomingIds,
        todoIds,
        focusIds,
        dismissedIds,
      });
    });
  };

  render() {
    let { ids, values, loading } = this.state;
    let { dueIds, doneIds, upcomingIds, todoIds, focusIds, dismissedIds, dormantIds } =
      this.state;
    let {
      expandDone,
      expandDue,
      expandFocus,
      expandUpcoming,
      expandTodo,
      expandDismissed,
      expandDormant,
    } = this.state;
    // let values = allValues?.filter(v => ids.includes(v.id))

    return (
      <ScrollView style={{ flex: 1 }}>
        <FilterBar hideFilters navigation={this.props.navigation} />
        <List quickComposer onSubmit={this.handleAddToDo} />

        {!!doneIds.length && (
          <TouchableOpacity
            style={styles.row}
            onPress={() => this.setState({ expandDone: !expandDone })}
          >
            <Text>Done Today</Text>
            <Text>({doneIds.length})</Text>
          </TouchableOpacity>
        )}
        {!!doneIds.length ? (
          expandDone ? (
            <List
              ids={doneIds}
              values={values}
              loading={loading}
              // onCancel={this.handle}
              hideButtons
              showDueDates
              showAncestorIcons
            />
          ) : (
            <View style={{ height: 20 }} />
          )
        ) : null}

        <TouchableOpacity
          style={styles.row}
          onPress={() => this.setState({ expandDue: !expandDue })}
        >
          <Text>Due</Text>
          <Text>({dueIds.length})</Text>
        </TouchableOpacity>
        {!expandDue ? (
          <View style={{ height: 20 }} />
        ) : !loading && !dueIds.length ? (
          <View
            style={[
              styles.row,
              { justifyContent: "center", alignItems: "center", height: 100 },
            ]}
          >
            <Text style={{ color: colors.trim }}>All caught up!</Text>
          </View>
        ) : (
          <List
            // quickComposer
            ids={dueIds}
            values={values}
            // allValues={allValues}
            loading={loading}
            onSubmit={this.handleAddToDo}
            onComplete={this.handleProgress}
            onCancel={this.handleRemoveToDo}
            onSortIds={this.handleSortIds}
            showDueDates
            showAncestorIcons
            // onUpdate={this.fetch}
          />
        )}

        <TouchableOpacity
          style={styles.row}
          onPress={() => this.setState({ expandUpcoming: !expandUpcoming })}
        >
          <Text>Upcoming</Text>
          <Text>
            ({upcomingIds.length}) {/*expandUpcoming ? '^' : 'v'*/}
          </Text>
        </TouchableOpacity>
        {expandUpcoming && !!upcomingIds.length ? (
          <List
            ids={upcomingIds}
            values={values}
            loading={loading}
            onComplete={this.handleProgress}
            // onCancel={this.handleRemoveToDo}
            showDueDates
            showAncestorIcons
          />
        ) : (
          <View style={{ height: 20 }} />
        )}

        <TouchableOpacity
          style={styles.row}
          onPress={() => this.setState({ expandTodo: !expandTodo })}
        >
          <Text>ToDo</Text>
          <Text>
            ({todoIds.length}) {/*expandTodo ? '^' : 'v'*/}
          </Text>
        </TouchableOpacity>
        {expandTodo && !!todoIds.length ? (
          <List
            ids={todoIds}
            values={values}
            loading={loading}
            onComplete={this.handleProgress}
            onCancel={this.handleRemoveToDo}
          />
        ) : (
          <View style={{ height: 20 }} />
        )}

        <TouchableOpacity
          style={styles.row}
          onPress={() => this.setState({ expandFocus: !expandFocus })}
        >
          <Text>Focus</Text>
          <Text>
            ({focusIds.length}) {/*expandFocus ? '^' : 'v'*/}
          </Text>
        </TouchableOpacity>
        {expandFocus && !!focusIds.length ? (
          <List ids={focusIds} values={values} loading={loading} />
        ) : (
          <View style={{ height: 20 }} />
        )}

        {!!dismissedIds.length && (
          <TouchableOpacity
            style={styles.row}
            onPress={() => this.setState({ expandDismissed: !expandDismissed })}
          >
            <Text>Dismissed</Text>
            <Text>
              ({dismissedIds.length}) {/*expandFocus ? '^' : 'v'*/}
            </Text>
          </TouchableOpacity>
        )}
        {expandDismissed && !!dismissedIds.length ? (
          <List
            ids={dismissedIds}
            values={values}
            loading={loading}
            hideButtons
            showDueDates
            customIcon={(style) => (
              <AntDesign
                name="upload"
                color={colors.lightForeground}
                style={[style, { opacity: 0.5 }]}
              />
            )}
            onComplete={this.handleUndismiss}
          />
        ) : (
          <View style={{ height: 20 }} />
        )}

        {!!dormantIds.length && (
          <TouchableOpacity
            style={styles.row}
            onPress={() => this.setState({ expandDormant: !expandDormant })}
          >
            <Text style={{ opacity: 0.5 }}>Dormant</Text>
            <Text style={{ opacity: 0.5 }}>({dormantIds.length})</Text>
          </TouchableOpacity>
        )}
        {expandDormant && !!dormantIds.length ? (
          <List
            ids={dormantIds}
            values={values}
            loading={loading}
            showDueDates
            showAncestorIcons
            onComplete={this.handleProgress}
            onCancel={this.handleRemoveToDo}
          />
        ) : (
          <View style={{ height: 20 }} />
        )}
      </ScrollView>
    );
  }

  handleSortIds = async (ids) => {
    let pref = await apiActions.request("preferences/1", "PATCH", {
      todo_ids: ids,
    });
    ids = pref.todo_ids;
    this.setState({ ids });
  };

  handleProgress = async (value, longPress = false) => {
    let success = await valueActions.progress(value.id);
    if (!!success) {
      let remove = true;
      if (longPress) {
        // if longpressing a todo list item, optionally keep it in the list
        let { todoIds } = this.state;
        if (todoIds.includes(value.id)) {
          let preserve = await valueActions.confirm(
            "confirm",
            null,
            "Keep item in todo list?"
          );
          remove = !preserve;
        }
      }
      if (remove) {
        this.handleRemoveToDo(value, false);
      }
    }
  };

  handleAddToDo = async (value) => {
    await prefActions.addToDo(value.id);
  };

  handleRemoveToDo = async (value, confirm = true) => {
    await prefActions.removeToDo(value.id, confirm);
  };

  handleUndismiss = async (value) => {
    await prefActions.undismiss(value.id);
  };
}

const styles = StyleSheet.create({
  row: {
    // flex: 1,
    alignSelf: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: 500,
    paddingHorizontal: 20,
    // marginTop: 20,
    // marginBottom: 20,
    // borderColor: colors.trim,
    // borderBottomWidth: 2,
    // backgroundColor: colors.subtle,
    // padding: 10,
  },
});
